export class TeemillError extends Error {
  constructor(message?: string) {
    super(message);

    // ? Restore prototype chain when extending built-in Error class
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
